import { Text } from '~/components/ui/Text';
import { logo } from '../../assets/images';
import { StyledContainer } from './ShopLogo.styled';

const ShopLogo = () => {
	return (
		<StyledContainer>
			<img src={logo} width={40} height={40} />
			<Text>
				ТЮНИНГ АТЕЛЬЕ
				<br />
				ЛОС - САНТОС
			</Text>
		</StyledContainer>
	);
};

export { ShopLogo };
